import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { connect } from 'react-redux';
import { Row, Col, Radio, Card, Divider, Button, Popconfirm } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import moment from 'moment';
import NumberFormat from 'react-number-format';

const API_HOST_URL = process.env.REACT_APP_API_URL

class TripsPosted extends Component {
    state = {
        selectedButton: 'Upcoming',
        trips: []
    }

    componentDidMount() {
        this.upcomingTrips();
    }

    upcomingTrips = () => {
        axios.get(`${API_HOST_URL}/api/trips/upcoming_trips_posted_by_user/?user_id=${this.props.loggedInUser.pk}`)
            .then(res => {
                this.setState({
                    trips: res.data
                },
                    () => {
                        console.log("trips fetched: ", this.state.trips)
                    })
            })
    }

    pastTrips = () => {
        axios.get(`${API_HOST_URL}/api/trips/past_trips_posted_by_user/?user_id=${this.props.loggedInUser.pk}`)
            .then(res => {
                this.setState({
                    trips: res.data
                },
                    () => {
                        console.log("trips fetched: ", this.state.trips)
                    })
            })
    }

    handleChange = e => {
        console.log("button clicked: ", e.target.value)
        this.setState({
            selectedButton: e.target.value
        })
        // this.fetchTrips()
        if (e.target.value == 'Upcoming') {
            this.upcomingTrips()
        } else if (e.target.value == 'Past') {
            this.pastTrips()
        }

    }

    handleDelete = (record) => {
        return axios.delete(`${API_HOST_URL}/api/trips/${record.id}/`,
            {
                headers: { Authorization: 'Token ' + this.props.token }
            })
            .then(res => {
                console.log(res)
                this.fetchTrips();
            })
            .catch(error => console.log(error));
    }

    render() {
        const { trips, selectedButton } = this.state
        return (
            <div>
                <div style={{ paddingTop: '30px' }}>
                    <Row>
                        <Col md={{ span: 18, offset: 3 }}>
                            <h2>Trips I Posted</h2>
                            <Radio.Group value={selectedButton} size="large" onChange={this.handleChange} >
                                <Radio.Button value="Upcoming" style={selectedButton == 'Upcoming' ? { backgroundColor: '#0099ff' } : {}}>
                                    <h4 style={selectedButton == 'Upcoming' ? { color: '#ffffff' } : {}}>Upcoming</h4>
                                </Radio.Button>
                                <Radio.Button value="Past" style={selectedButton == 'Past' ? { backgroundColor: '#0099ff' } : {}}>
                                    <h4 style={selectedButton == 'Past' ? { color: '#ffffff' } : {}}>Past</h4>
                                </Radio.Button>
                            </Radio.Group>
                        </Col>
                    </Row>
                </div>
                <div style={{ paddingTop: '24px' }}>
                    {
                        trips.length > 0 ?
                            trips.map(trip => (
                                <div>
                                <Row gutter={16} key={trip.id}>
                                    <Col md={{ span: 18, offset: 3 }}>
                                        <Card>
                                            <Row>
                                                <Col md={{ span: 12 }}>
                                                    <h4 style={{ fontWeight: "bold", color: '#0099ff' }}>
                                                        <Link to={`/trip-detail/${trip.id}`}> {trip.originCity} to {trip.destinationCity}</Link>
                                                    </h4>
                                                    <h4 style={{ fontWeight: "normal" }} className="GrayText">{moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "hh:mm").format("hh:mm A")}</h4>
                                                </Col>
                                                <Col md={{ span: 11, offset: 1 }}>
                                                    <h4 style={{ fontWeight: "bold", color: '#0099ff' }}>
                                                        <Link to={`/trip-requests/${trip.id}`}> {trip.bookings} Requests</Link><br />
                                                    </h4>
                                                    <h4 style={{ fontWeight: "normal", color: "green" }}>
                                                        <Link to={`/trip-requests/${trip.id}`}> {trip.approvedBookings} Requests Approved {trip.numberOfSeatsBooked > 0 && (<span>(<NumberFormat value={trip.numberOfSeatsBooked * trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} style={{ color: "green" }} />)</span>)}</Link>
                                                    </h4>
                                                </Col>
                                            </Row>
                                            <Popconfirm title="Sure to delete Trip?" onConfirm={() => this.handleDelete(trip)}>
                                                <Button type="primary" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }}>Delete</Button>
                                            </Popconfirm>

                                        </Card>
                                    </Col>
                                </Row>
                                <br/>
                                </div>
                            ))
                            :
                            <div>
                                <Row>
                                    <Col md={{ span: 18, offset: 3 }}>
                                        <h4>You don't have any {selectedButton} trips.</h4>
                                    </Col>
                                </Row>
                            </div>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null,
        loggedInUser: state.currentUser,
        token: state.token
    }
}

export default connect(mapStateToProps, null)(TripsPosted);
